// Cart Collection Validator - Place in assets/cart-validator.js

(function() {
    // Prevent double-loading
    if (window.cartValidatorLoaded) {
        console.log('Cart validator already loaded, skipping duplicate');
        return;
    }
    window.cartValidatorLoaded = true;
    
    console.log('Collection Validator: Script loaded');
    
    // Configuration
    var restrictedCollections = {
        '525761577270': 'Main Menu',
        '525760430390': 'Holiday Menu 1',
        '525760463158': 'Holiday Menu 2',
        '525760495926': 'Holiday Menu 3',
        '528014115126': 'New Years',
        '529286005046': 'Super Bowl',
        '529285972278': 'Valentines Day',
        '529286070582': 'Easter',
        '529286103350': 'Passover',
        '529286136118': 'Mothers Day',
        '529286201654': 'Fathers Day',
        '529286267190': 'Rosh Hashana',
        '529286332726': 'Yom Kippur',
        '529290756406': 'Rotating Holiday'
    };
    
    var collectionNamesCache = {};
    var MINIMUM_ORDER_AMOUNT = 2500; // $25.00 in cents // Minimum removed on 1/16/2025 for specials
    var HOLIDAY_MENU_2_MINIMUM = 0000; // $0.00 in cents for Holiday Menu 2 only (temporarily set to 0 12/19/25)
    var HOLIDAY_MENU_2_ID = '525760463158';
    var THANKSGIVING_ID = '525760430390'; // Holiday Menu 1 — no minimum
    var isValidating = false;
    var lastValidationState = null;
    var currentErrors = [];
    var lastValidationTime = 0;
    var VALIDATION_COOLDOWN = 1000; // Minimum 1 second between validations

    // Fetch cart data
    function getCart() {
        return fetch('/cart.js').then(function(response) {
            return response.json();
        });
    }

    // Get collection name from Shopify
    function getCollectionName(collectionId) {
        if (collectionNamesCache[collectionId]) {
            console.log('Using cached name for', collectionId, ':', collectionNamesCache[collectionId]);
            return Promise.resolve(collectionNamesCache[collectionId]);
        }
        
        console.log('Fetching collection name for ID:', collectionId);
        
        return fetch('/collections.json')
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                var collection = data.collections.find(function(col) {
                    return col.id.toString() === collectionId.toString();
                });
                
                if (collection) {
                    console.log('Found collection:', collection.title);
                    collectionNamesCache[collectionId] = collection.title;
                    return collection.title;
                }
                
                return restrictedCollections[collectionId] || 'Unknown Collection';
            })
            .catch(function(error) {
                console.error('Error fetching collection:', error);
                return restrictedCollections[collectionId] || 'Unknown Collection';
            });
    }

    // Get all collection names
    function getAllCollectionNames(collectionIds) {
        var promises = collectionIds.map(function(id) {
            return getCollectionName(id);
        });
        return Promise.all(promises);
    }

    // Main validation function
    function validateCart() {
        // Prevent rapid successive validations
        var now = Date.now();
        if (now - lastValidationTime < VALIDATION_COOLDOWN) {
            console.log('Validation cooldown active, skipping');
            return Promise.resolve(lastValidationState);
        }
        
        if (isValidating) {
            console.log('Validation in progress, skipping');
            return Promise.resolve(lastValidationState);
        }
        
        lastValidationTime = now;
        isValidating = true;
        console.log('Collection Validator: Running validation...');
        
        return getCart().then(function(cart) {
            console.log('Cart data:', cart);
            currentErrors = [];
            
            if (!cart.items || cart.items.length === 0) {
                console.log('Cart is empty');
                isValidating = false;
                lastValidationState = true;
                hideValidationError();
                enableCheckout();
                return true;
            }

            // Find restricted collections in cart
            var collectionsInCart = {};
            var cartItemElements = document.querySelectorAll('[data-cart-item-collection-ids]');
            console.log('Found', cartItemElements.length, 'cart items with collection data');
            
            cartItemElements.forEach(function(element) {
                var collectionIds = element.getAttribute('data-cart-item-collection-ids');
                if (collectionIds) {
                    var ids = collectionIds.split(',');
                    ids.forEach(function(id) {
                        var cleanId = id.trim();
                        if (restrictedCollections[cleanId]) {
                            console.log('Found restricted collection ID:', cleanId);
                            collectionsInCart[cleanId] = true;
                        }
                    });
                }
            });
            
            var foundCollections = Object.keys(collectionsInCart);
            console.log('Restricted collections found:', foundCollections);
            
            // Check if Holiday Menu 2 is in cart
            var hasHolidayMenu2 = foundCollections.includes(HOLIDAY_MENU_2_ID) ||
                                  foundCollections.includes(THANKSGIVING_ID);
            
            // Always fetch collection names if we have any restricted collections
            if (foundCollections.length === 0) {
                // No restricted collections, just validate minimum
                return validateMinimumAmount(cart, false);
            }
            
            // Fetch collection names first
            console.log('Fetching names for collections:', foundCollections);
            return getAllCollectionNames(foundCollections).then(function(collectionNames) {
                console.log('Retrieved collection names:', collectionNames);
                
                // Check if multiple incompatible collections
                if (foundCollections.length > 1) {
                    var namesString = collectionNames.join(', ');
                    currentErrors.push({
                        type: 'collections',
                        message: 'Your cart contains items from multiple menus: <strong>' + namesString + '</strong>. Please keep only items from one menu to check out.'
                    });
                }
                
                // Check minimum amount (use Holiday Menu 2 minimum if applicable)
                var cartTotal = cart.total_price;
                var minimumToUse = hasHolidayMenu2 ? HOLIDAY_MENU_2_MINIMUM : MINIMUM_ORDER_AMOUNT;
                console.log('Cart total:', cartTotal, 'cents (Minimum:', minimumToUse, 'cents)');
                
                if (cartTotal < minimumToUse) {
                    var currentAmount = (cartTotal / 100).toFixed(2);
                    var minimumAmount = (minimumToUse / 100).toFixed(2);
                    var remainingAmount = ((minimumToUse - cartTotal) / 100).toFixed(2);
                    currentErrors.push({
                        type: 'minimum',
                        message: 'Minimum order <strong>$' + minimumAmount + '</strong>. Please add <strong>$' + remainingAmount + '</strong> more to check out.'
                    });
                }
                
                isValidating = false;
                
                if (currentErrors.length > 0) {
                    console.log('VALIDATION FAILED:', currentErrors.length, 'errors');
                    lastValidationState = false;
                    showValidationError(currentErrors);
                    disableCheckout();
                    return false;
                } else {
                    console.log('VALIDATION PASSED');
                    lastValidationState = true;
                    hideValidationError();
                    enableCheckout();
                    return true;
                }
            });
        }).catch(function(error) {
            console.error('Cart validation error:', error);
            isValidating = false;
            lastValidationState = true;
            hideValidationError();
            enableCheckout();
            return true;
        });
    }

    // Validate minimum amount only
    function validateMinimumAmount(cart, hasHolidayMenu2) {
        var cartTotal = cart.total_price;
        var minimumToUse = hasHolidayMenu2 ? HOLIDAY_MENU_2_MINIMUM : MINIMUM_ORDER_AMOUNT;
        console.log('Cart total:', cartTotal, 'cents (Minimum:', minimumToUse, 'cents)');
        
        if (cartTotal < minimumToUse) {
            var currentAmount = (cartTotal / 100).toFixed(2);
            var minimumAmount = (minimumToUse / 100).toFixed(2);
            var remainingAmount = ((minimumToUse - cartTotal) / 100).toFixed(2);
            currentErrors.push({
                type: 'minimum',
                message: 'Minimum order amount is <strong>$' + minimumAmount + '</strong>. Your current total is <strong>$' + currentAmount + '</strong>. Please add <strong>$' + remainingAmount + '</strong> more to proceed.'
            });
        }
        
        isValidating = false;
        
        if (currentErrors.length > 0) {
            console.log('VALIDATION FAILED:', currentErrors.length, 'errors');
            lastValidationState = false;
            showValidationError(currentErrors);
            disableCheckout();
            return false;
        } else {
            console.log('VALIDATION PASSED');
            lastValidationState = true;
            hideValidationError();
            enableCheckout();
            return true;
        }
    }

    // Show validation error
    function showValidationError(errors) {
        console.log('Showing validation errors:', errors);
        
        // Remove existing errors
        var existingCollectionError = document.getElementById('collection-validation-error');
        var existingMinimumError = document.getElementById('minimum-order-error');
        if (existingCollectionError) existingCollectionError.remove();
        if (existingMinimumError) existingMinimumError.remove();
        
        // Determine if we're on cart page or drawer
        var isCartPage = document.querySelector('#main-cart-footer') !== null;
        var cartDrawer = document.querySelector('cart-drawer');
        var isDrawerActive = cartDrawer && (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('is-open'));
        
        // If we're on cart page and drawer is NOT active, show on cart page
        // If drawer is active (regardless of page), show in drawer
        var useDrawer = isDrawerActive;
        var usePage = isCartPage && !isDrawerActive;
        
        console.log('Display location - Cart page:', usePage, 'Drawer:', useDrawer);
        
        var insertLocation = null;
        
        if (useDrawer) {
            insertLocation = document.querySelector('.drawer__footer, cart-drawer .cart-drawer__footer, #CartDrawer-Footer');
            if (insertLocation) {
                insertLocation = insertLocation.parentNode;
                console.log('Using cart drawer for errors');
            }
        } else if (usePage) {
            insertLocation = document.querySelector('#main-cart-footer .page-width');
            console.log('Using cart page for errors');
        }
        
        if (!insertLocation) {
            console.error('Could not find location to insert errors');
            return;
        }
        
        // Separate errors by type
        var collectionError = errors.find(function(e) { return e.type === 'collections'; });
        var minimumError = errors.find(function(e) { return e.type === 'minimum'; });
        
        // Show collection error first (if exists)
        if (collectionError) {
            var collectionDiv = document.createElement('div');
            collectionDiv.id = 'collection-validation-error';
            collectionDiv.style.cssText = '';
            collectionDiv.innerHTML = '<p>' + collectionError.message + '</p>';
            
            if (useDrawer) {
                var footerElement = insertLocation.querySelector('.drawer__footer, .cart-drawer__footer');
                if (footerElement) {
                    insertLocation.insertBefore(collectionDiv, footerElement);
                } else {
                    insertLocation.appendChild(collectionDiv);
                }
            } else {
                insertLocation.insertBefore(collectionDiv, insertLocation.firstChild);
            }
        }
        
        // Show minimum error second (below collection error)
        if (minimumError) {
            var minimumDiv = document.createElement('div');
            minimumDiv.id = 'minimum-order-error';
            minimumDiv.style.cssText = '';
            minimumDiv.innerHTML = '<p>' + minimumError.message + '</p>';
            
            if (useDrawer) {
                var footerElement = insertLocation.querySelector('.drawer__footer, .cart-drawer__footer');
                if (footerElement) {
                    insertLocation.insertBefore(minimumDiv, footerElement);
                } else {
                    insertLocation.appendChild(minimumDiv);
                }
            } else {
                // Insert after collection error if it exists, otherwise at top
                var collectionErrorElement = document.getElementById('collection-validation-error');
                if (collectionErrorElement && collectionErrorElement.nextSibling) {
                    insertLocation.insertBefore(minimumDiv, collectionErrorElement.nextSibling);
                } else if (collectionErrorElement) {
                    collectionErrorElement.parentNode.insertBefore(minimumDiv, collectionErrorElement.nextSibling);
                } else {
                    insertLocation.insertBefore(minimumDiv, insertLocation.firstChild);
                }
            }
        }
        
        console.log('Error messages inserted');
        
        // Monitor and re-insert if removed
        if (window.validationCheckInterval) {
            clearInterval(window.validationCheckInterval);
        }
        window.validationCheckInterval = setInterval(function() {
            if (lastValidationState === false) {
                var collectionError = document.getElementById('collection-validation-error');
                var minimumError = document.getElementById('minimum-order-error');
                
                if (!collectionError && !minimumError) {
                    console.log('Errors were removed, re-validating...');
                    clearInterval(window.validationCheckInterval);
                    setTimeout(validateCart, 100);
                }
            }
        }, 1000);
    }

    // Hide validation error
    function hideValidationError() {
        if (window.validationCheckInterval) {
            clearInterval(window.validationCheckInterval);
            window.validationCheckInterval = null;
        }
        
        var collectionError = document.getElementById('collection-validation-error');
        var minimumError = document.getElementById('minimum-order-error');
        
        if (collectionError) {
            collectionError.remove();
            console.log('Collection error message removed');
        }
        if (minimumError) {
            minimumError.remove();
            console.log('Minimum order error message removed');
        }
    }

    // Disable checkout
    function disableCheckout() {
        console.log('Disabling checkout buttons');
        
        // Disable regular cart page checkout buttons
        var checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button, .btn--checkout, button[type="submit"][name="checkout"], .cart__checkout');
        checkoutButtons.forEach(function(btn) {
            btn.setAttribute('disabled', 'disabled');
            btn.style.opacity = '0.5';
            btn.style.pointerEvents = 'none';
        });
        
        // Disable cart drawer checkout button
        var drawerCheckout = document.querySelector('#CartDrawer-Checkout, cart-drawer button[name="checkout"]');
        if (drawerCheckout) {
            drawerCheckout.setAttribute('disabled', 'disabled');
            drawerCheckout.style.opacity = '0.5';
            drawerCheckout.style.pointerEvents = 'none';
        }
        
        // Disable dynamic checkout buttons (both page and drawer)
        var dynamicCheckout = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .cart-drawer__footer .shopify-payment-button');
        dynamicCheckout.forEach(function(element) {
            element.style.opacity = '0.5';
            element.style.pointerEvents = 'none';
            element.style.filter = 'grayscale(100%)';
        });
    }

    // Enable checkout
    function enableCheckout() {
        console.log('Enabling checkout buttons');
        
        // Enable regular cart page checkout buttons
        var checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button, .btn--checkout, button[type="submit"][name="checkout"], .cart__checkout');
        checkoutButtons.forEach(function(btn) {
            btn.removeAttribute('disabled');
            btn.style.opacity = '';
            btn.style.pointerEvents = '';
        });
        
        // Enable cart drawer checkout button
        var drawerCheckout = document.querySelector('#CartDrawer-Checkout, cart-drawer button[name="checkout"]');
        if (drawerCheckout) {
            drawerCheckout.removeAttribute('disabled');
            drawerCheckout.style.opacity = '';
            drawerCheckout.style.pointerEvents = '';
        }
        
        // Enable dynamic checkout buttons
        var dynamicCheckout = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .cart-drawer__footer .shopify-payment-button');
        dynamicCheckout.forEach(function(element) {
            element.style.opacity = '';
            element.style.pointerEvents = '';
            element.style.filter = '';
        });
    }

    // Initialize validation immediately — checkout button is server-rendered as disabled,
    // so we want validation to run as soon as possible to enable it for valid carts.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', validateCart);
    } else {
        validateCart();
    }

    // Cart-update events invalidate the cooldown cache so the next validation
    // re-reads /cart.js instead of returning a stale lastValidationState.
    function forceRevalidate() {
        lastValidationTime = 0;
        setTimeout(validateCart, 100);
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
            console.log('Cart updated');
            forceRevalidate();
        });
    }

    document.addEventListener('cart:updated', forceRevalidate);

    document.addEventListener('shopify:section:load', forceRevalidate);
    
    // Watch for cart changes
    var cartObserver = new MutationObserver(function(mutations) {
        var shouldRevalidate = false;
        mutations.forEach(function(mutation) {
            if (mutation.target.id === 'main-cart-items' ||
                mutation.target.id === 'CartDrawer-CartItems' ||
                (mutation.target.closest && (mutation.target.closest('#main-cart-items') || mutation.target.closest('cart-drawer')))) {
                shouldRevalidate = true;
            }
        });
        if (shouldRevalidate) {
            forceRevalidate();
        }
    });
    
    var cartElement = document.querySelector('#main-cart-items');
    if (cartElement) {
        cartObserver.observe(cartElement, { 
            childList: true, 
            subtree: true
        });
    }
    
    // Also observe cart drawer
    var cartDrawerElement = document.querySelector('cart-drawer, #CartDrawer');
    if (cartDrawerElement) {
        cartObserver.observe(cartDrawerElement, { 
            childList: true, 
            subtree: true
        });
    }
    
    // Listen for cart drawer opening
    document.addEventListener('cart-drawer:open', function() {
        console.log('Cart drawer opened');
        forceRevalidate();
    });

    // MutationObserver to detect when drawer becomes active
    var drawerObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                var target = mutation.target;
                if (target.classList.contains('active') || target.classList.contains('is-open')) {
                    console.log('Cart drawer activated');
                    forceRevalidate();
                }
            }
        });
    });
    
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
        drawerObserver.observe(drawer, { attributes: true });
    }
    
    // Prevent checkout clicks when invalid or not-yet-validated.
    // Using "!== true" (rather than "=== false") closes the initial-load race
    // where lastValidationState is null during the first validation pass.
    document.addEventListener('click', function(e) {
        var checkoutBtn = e.target.closest('[name="checkout"], .cart__checkout-button, .shopify-payment-button__button');
        if (checkoutBtn && lastValidationState !== true) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Checkout prevented - validation state:', lastValidationState);
            return false;
        }
    }, true);

    // Capture-phase submit listener — catches form submissions before PickEasy's
    // own submit handler runs, and treats null (not-yet-validated) as a block so
    // the initial-load race window can't slip through.
    document.addEventListener('submit', function(e) {
        var form = e.target;
        if (!form || (form.id !== 'CartDrawer-Form' && form.id !== 'cart')) return;

        if (lastValidationState !== true) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Submit prevented - validation state:', lastValidationState);
            // Force a re-check so the error message is up to date.
            forceRevalidate();
            return false;
        }
    }, true);

    console.log('Collection Validator: Setup complete');
})();